export enum MarkName {
  Strong = 'strong',
  Em = 'em',
  Strikethrough = 'strikethrough',
  Underline = 'underline',
  Link = 'link',
  Size = 'font_size',
  Color = 'color',
  BackgroundColor = 'background_color',
}
